import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { SnackbarEffects } from './snackbar.effects';

@NgModule({
  imports: [MatSnackBarModule, EffectsModule.forFeature([SnackbarEffects])],
})
export class SnackbarModule {}
